<!--
 * @Description: 
-->
<!--
 * @Description: 户号绑定
--> 
<template>
  <div class="code-bind">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      v-show="$comm.titleShow()"
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <div class="banner">
      <div style="height:25px;"></div>
      <div class="avatar">
        <img v-if="avatar" :src="avatar"/>
        <img v-else :src="require('../../assets/images/default.png')">
      </div>
      <div class="username">{{nickname?nickname:''}}</div>
    </div>
    <!-- <van-tabs color="#1677FF" v-model="active" sticky> -->
      <!-- <van-tab :title="'户号绑定'"> -->
        <bind-form></bind-form>
      <!-- </van-tab> -->
      <!-- <van-tab :title="'户号查询'">
        <query-form></query-form>
      </van-tab> -->
    <!-- </van-tabs> -->
  </div>
</template>

<script>
import BindForm from './BindForm'
// import QueryForm from './QueryForm'
export default {
  name: 'PersonCenter',
  components: {
    BindForm,
    // QueryForm
  },
  data() {
    return {
      active: 0,
      nickname: localStorage.getItem('nickname'),
      avatar: localStorage.getItem('avatar'),
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="less" scoped>
.code-bind{
  .banner{
    height: 170px;
    background: linear-gradient(171deg, rgba(114, 211, 250, 0.86) 0%, rgba(91, 149, 245, 0.93) 100%);
    background-size: 100% 100%;
    text-align: center;
    .avatar{
      img{
        width:70px;
        height:70px;
        border:5px solid rgba(33,91,46,0.34);
        border-radius: 50%;
      }
    }
    .username{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(255,255,255,1);
      margin-top: 3px;
    }
  }
}
</style>